import { Component, inject, Input, OnInit, Output } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { InitialAssessmentForm } from '../../data/initial-assessment-form';
import { BusinessDetails } from '../../models/business-details';
import { Observable } from 'rxjs';
import { LookupItem } from '../../models/lookup-item';
import { LookupDataService } from '../../services/lookup-data.service';
import { IFormComponent } from '../../models/i-form-component';

@Component({
  selector: 'app-business-skills',
  templateUrl: './business-skills.component.html',
  styleUrl: './business-skills.component.scss'
})
export class BusinessSkillsComponent implements OnInit, IFormComponent {
  @Input() model!: InitialAssessmentForm;
  @Input() businessExperience!: LookupItem[];

  formBuilder = inject(NonNullableFormBuilder);


  isFormValid(): boolean {
    return this.businessSkillsForm.valid;
  }

  markFormAsTouched(): void {
    this.businessSkillsForm.markAllAsTouched();
  }
  
  ngOnInit(): void {

    this.model = this.model || new InitialAssessmentForm();
    this.model.business = this.model.business || new BusinessDetails();

    // Bind form to model data
    this.businessSkillsForm.patchValue(this.model.business);

    // Subscribe to form changes to update model
    this.businessSkillsForm.valueChanges.subscribe(value => {
      this.model.business = {
        ...this.model.business!,
        ...value
      }
    });
  }

  businessSkillsForm = this.formBuilder.group({
    assetsRecent: [''],
    assetsPrior: [''],
    assetsTransferred: [''],
    businessYears: [null as LookupItem | null],
    investmentYears: [null as LookupItem | null],
    businessHistory: [''],
    hasPatents: [''],
    patentDetails: [''],
    hasTrademarks: [''],
    trademarkDetails: [''],
    hasJointVenture: [''],
    joinVentureDetails: [''],
    isExport: [''],
    exportDetails: [''],
    isGazelle: [''],
    gazelleDetails: [''],
    receivedFundingGrants: [''],
    fundingGrantDetails: [''],
    receivedFundingCapital: [''],
    fundingCapitalDetails: ['']
  });

}
  